export const SET_VENDOR_CUSTOMER_STATEMENT = 'SET_VENDOR_CUSTOMER_STATEMENT';